import { Component, OnInit } from '@angular/core';
import { TransferHttpService } from '../../../../services/transfer-http/transfer-http.service';
import { AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { Departments, WorkSections } from '../../hrCommon';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'departments-table',
  templateUrl: './departments-table.component.html',
  styleUrls: ['./departments-table.component.css'],
  providers: [MainGridService]
})
export class DepartmentsTableComponent implements OnInit {

  tablePermissions: AimsCommonTablePermissions = {
    create: false, // Set below in constructor
    update: false, // Set below in constructor
    delete: false,
  };
  initialTableElement;
  initialWorkSectionTableElement;

  departments: Observable<any>;
  departmentsHeader: AimsCommonTableHeader[] = [
    { key: 'rowExpand', label: '', type: 'rowExpand', filter: false },
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'department', label: 'Department', type: 'string', validatorOrOpts: [Validators.required, Validators.maxLength(50)]},
    { key: 'managerId', label: 'Department Manager', type: 'dynamic', filterType: 'dynamic' },
    { key: 'departmentCode', label: 'Department Code', type: 'string', validatorOrOpts: [Validators.required, Validators.maxLength(50)]},
  ];

  workSectionsResults: any[];
  mainWorkSectionsService;
  workSections: Observable<any>;
  workSectionsHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'workSection', label: 'Work Section', type: 'string',validatorOrOpts: [Validators.required, Validators.maxLength(22)]},
    { key: 'departmentId', label: 'Department', type: 'dynamic', filterType: 'dynamic', validatorOrOpts: [Validators.required] },
    { key: 'leadId', label: 'Work Section Lead', type: 'dynamic', filterType: 'dynamic', validatorOrOpts: [Validators.required] }
  ];

  departmentValues = this.transferHttp.getSingle('Common/GetAllDepartmentsForDropdown');
  leadValues = this.transferHttp.getSingle('Common/GetActiveEmployeesForDropDown');
  managerValues = this.transferHttp.getSingle('hr/GetManagersForDropdown');

  newDepartments() {
    return new Departments();
  }

  newWorkSections() {
    return new WorkSections();
  }

  constructor(
    private transferHttp: TransferHttpService,
    public permissions: PermissionsService,
    public mainGridService: MainGridService<any>
  ) {
    this.tablePermissions.create = permissions.canCreate(permissions.ComponentID.HumanResourcesConfig);
    this.tablePermissions.update = permissions.canUpdate(permissions.ComponentID.HumanResourcesConfig);

    this.departments = this.mainGridService.getAll('Hr/GetDepartments', 'Hr/SaveDepartments');
 
    this.mainWorkSectionsService = new MainGridService<any>(this.transferHttp);
    this.workSections = this.mainWorkSectionsService.getAll('Hr/GetWorkSections', 'Hr/SaveWorkSections');
    this.workSections.subscribe(data => this.workSectionsResults = data)
 
  }

  ngOnInit(): void {
    this.initialTableElement = this.newDepartments();
    this.initialWorkSectionTableElement = this.newWorkSections();
  }

  handleRowUpdate(update: TableRowUpdate): void {
    this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe());
  }

  handleRowAdd(update: TableRowUpdate): void {
    this.mainGridService.add(update.newRow).subscribe(update.handleSubscribe());
  }

  handleWorkSectionRowUpdate(update: TableRowUpdate): void {
    this.mainWorkSectionsService.updateByObject(update.newRow, update.oldRow).subscribe(update.handleSubscribe());
  }

  handleWorkSectionRowAdd(update: TableRowUpdate): void {
    this.mainWorkSectionsService.add(update.newRow).subscribe(update.handleSubscribe());
  }

  ngOnDestroy() {
  }
}
